// extracted by mini-css-extract-plugin
export var numpadContainer = "_pl-1";
export var phoneButton = "_pl-0";